import * as React from 'react';

import { Title } from 'common/components';
import { Section } from 'templates/core';
import FactCore from '../components/FactCore';
import { STATUSES, STATUSES_OPTIONS } from 'common/consts';

const defaultValues = {
  status: STATUSES_OPTIONS.filter(({ value }) => value === STATUSES.DRAFT),
};

const FactsCreate = () => {
  return (
    <>
      <Section>
        <Title size="big">Create Fact</Title>
      </Section>
      <FactCore defaultValues={defaultValues} />
    </>
  );
};

export default FactsCreate;
